import script from "./DialogPatrol.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogPatrol.vue?vue&type=script&setup=true&lang=ts"

import "./DialogPatrol.vue?vue&type=style&index=0&id=3b1a9ef0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b1a9ef0"]])

export default __exports__